'use strict';

/*global elementInViewport */
/*global elementIsVisible */
/*global blockElement */
/*global unBlockElement */
/*global isEmpty */
/*global initialize*/

(function ($) {
  var methods = {
    init: function (/*options*/) {
      // options are not used
      //var opts = $.extend({}, $.fn.k2_charCounter.defaults, options);

      return this.each(function () {
        var _this = this;
        var $this = $(this);

        if ($this.hasClass('load-other-items-init')) {
          return;
        }

        $this.addClass('load-other-items-init');

        $this.on('click', function (e) {
          methods.doLoadOtherItems.apply(_this, e);
          return false;
        });

        methods.doLoadOtherItems.apply(_this);
      });
    },

    loadOtherItems: function () {
      var _this = this;
      var $this = $(this);

      if ($this.closest('.modal').length && elementIsVisible($this.closest('.loadOtherItemsWrapper'), $this.closest('.modal-body'))) {
        methods.doLoadOtherItems.apply(_this);
      } else if ($this.closest('.widget').length && !$this.closest('.widget-height-auto').length && !$this.closest('.dashboard-widget-full').length && elementIsVisible($this.closest('.loadOtherItemsWrapper'), $this.closest('.widget-content'))) {
        methods.doLoadOtherItems.apply(_this);
      } else if (elementInViewport($this.get(0))) {
        methods.doLoadOtherItems.apply(_this);
      }
    },

    doLoadOtherItems: function () {
      var _this = this;
      var $this = $(this);

      if (!$this.hasClass('loading')) {
        var $wrapper = $this.closest('.loadOtherItemsWrapper');
        blockElement($wrapper);
        $this.addClass('loading');
        var $container = $this.closest('.dataContainerWrapper').find('.dataContainer');
        var formContainer = !isEmpty($this.data('form_container')) ? $this.data('form_container') : '.sidebar';
        var $filterForm = $(formContainer + ' form');

        $.post($this.data('action') + '?' + $this.data('custom_params') + '&page_state=' + $this.data('page_state') + '&offset=' + $this.data('offset'), $filterForm.serialize(), function (res) {
          $this.removeClass('loading');
          unBlockElement($wrapper);
          if (res.msg === 'SUCCESS') {
            var $data = $(res.data.html);
            $container.append($data);

            if ('initialize' in window) {
              initialize($data);
            }

            $this.data('offset', res.data.offset);
            $this.data('page_state', res.data.page_state);

            if (res.data.page_state === '') {
              $wrapper.hide();
            } else {
              methods.loadOtherItems.apply(_this);
            }
          }
        });
      }

      return false;
    }
  };

  $.fn.k2_loadOtherItems = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_loadOtherItems');
    }
  };

  $.fn.k2_loadOtherItems.defaults = {};

  $(window).on('scroll resize', function () {
    $('.load-other-items-init:visible').each(function () {
      $(this).k2_loadOtherItems('loadOtherItems');
    });
  });

  $('body').on('scrollModal', '.modal', function () {
    $('.load-other-items-init:visible').each(function () {
      $(this).k2_loadOtherItems('loadOtherItems');
    });
  });

  $('body').on('scrollWidget', '.widget', function () {
    $('.load-other-items-init:visible').each(function () {
      $(this).k2_loadOtherItems('loadOtherItems');
    });
  });
})(jQuery);
